import jenny_hayes from "../images/post/jenny_hayes.jpg"
import fiona_wood from "../images/post/fiona_wood.jpg"
import jeffrey_rosenfeld from "../images/post/jeffrey_rosenfeld.jpg"
import rob_moodie from "../images/post/rob_moodie.jpg"
import maithri_goonetilleke from "../images/post/maithri_goonetilleke.jpg"
import chatu_yapa from "../images/post/chatu_yapa.jpg"
import sally_graddon from "../images/post/sally_graddon.jpg"
import jason_lam from "../images/post/jason_lam.jpg"
import steve_trumble from "../images/post/steve_trumble.jpg"
import ranjana_srivastava from "../images/post/ranjana_srivastava.jpg"
import mark_cook from "../images/post/mark_cook.jpg"
import nick_carr from "../images/post/nick_carr.jpg"
import peter_choong from "../images/post/peter_choong.jpg"
import hon_weng_chong from "../images/post/hon_weng_chong.jpg"
import joe_rotella from "../images/post/joe_rotella.jpg"
import olivia_lesslar from "../images/post/olivia_lesslar.jpg"
import rebecca_stewart from "../images/post/rebecca_stewart.jpg"
import tilman_ruff from "../images/post/tilman_ruff.jpg"
import glenn_begley from "../images/post/glenn_begley.jpg"
import anita_elias from "../images/post/anita_elias.jpg"
import ginni_mansberg from "../images/post/ginni_mansberg.jpg"
import rinaldo_bellomo from "../images/post/rinaldo_bellomo.jpg"
import frank_gaillard from "../images/post/frank_gaillard.jpg"
import grace_dugan from "../images/post/grace_dugan.jpg"
import tal_rapke from "../images/post/tal_rapke.jpg"
import sally_bell from "../images/post/sally_bell.jpg"
import jonathan_king from "../images/post/jonathan_king.jpg"
import helen_malcolm from "../images/post/helen_malcolm.jpg"
import peter_morley from "../images/post/peter_morley.jpg"
import frank_oberklaid from "../images/post/frank_oberklaid.jpg"
import kelley_withy from "../images/post/kelley_withy.jpg"
import joseph_proietto from "../images/post/joseph_proietto.jpg"
import andrew_pattison from "../images/post/andrew_pattison.jpg"
import michael_bonning from "../images/post/michael_bonning.jpg"
import yvonne_ho from "../images/post/yvonne_ho.jpg"
import adir_shiffman from "../images/post/adir_shiffman.jpg"
import louise_teo from "../images/post/louise_teo.jpg"
import jim_black from "../images/post/jim_black.jpg"
import brendan_nelson from "../images/post/brendan_nelson.jpg"
import yumiko_kadota from "../images/post/yumiko_kadota.jpg"
import dr_karl from "../images/post/dr_karl.jpg"
import patrick_mcgorry from "../images/post/patrick_mcgorry.jpg"
import raffy_halim from "../images/post/raffy_halim.jpg"
import renee_lim from "../images/post/renee_lim.jpg"
import richard_di_natale from "../images/post/richard_di_natale.jpg"
import ashe_coxon from "../images/post/ashe_coxon.jpg"
import simon_judkins from "../images/post/simon_judkins.jpg"
import linny_kimly_phuong from "../images/post/linny_kimly_phuong.jpg"
import tim_read from "../images/post/tim_read.jpg"
import chandrashan_perera from "../images/post/chandrashan_perera.jpg"
import kate_tyson from "../images/post/kate_tyson.jpg"
import exam_edition_1 from "../images/post/exam_edition_1.jpg"
import exam_edition_2 from "../images/post/exam_edition_2.jpg"
import michael_levitt from "../images/post/michael_levitt.jpg"
import murray_esler from "../images/post/murray_esler.jpg"
import matthew_chan from "../images/post/matthew_chan.jpg"
import ian_harris from "../images/post/ian_harris.jpg"
import peter_blamey from "../images/post/peter_blamey.jpg"
import june_brundell from "../images/post/june_brundell.jpg"
import skye_kinder from "../images/post/skye_kinder.jpg"
import bradley_frew from "../images/post/bradley_frew.jpg"
import melanie_tan from "../images/post/melanie_tan.jpg"
import brian_spain from "../images/post/brian_spain.jpg"
import evelyn_chan from "../images/post/evelyn_chan.jpg"
import katie_allen from "../images/post/katie_allen.jpg"
import roy_robins from "../images/post/roy_robins.jpg"
import marian_dover from "../images/post/marian_dover.jpg"
import jan_coles from "../images/post/jan_coles.jpg"
import thailand_covidsation from "../images/post/thailand_covidsation.jpg"
import melissa_kang from "../images/post/melissa_kang.jpg"
import bronwyn_king from "../images/post/bronwyn_king.jpg"
import allison_hempenstall from "../images/post/allison_hempenstall.jpg"
import david_lam from "../images/post/david_lam.jpg"
import robbie_gillies from "../images/post/robbie_gillies.jpg"
import khoa_cao from "../images/post/khoa_cao.jpg"

const post_images_array = [
    jenny_hayes,
    fiona_wood,
    jeffrey_rosenfeld,
    rob_moodie,
    maithri_goonetilleke,
    chatu_yapa,
    sally_graddon,
    jason_lam,
    steve_trumble,
    ranjana_srivastava,
    mark_cook,
    nick_carr,
    peter_choong,
    hon_weng_chong,
    joe_rotella,
    olivia_lesslar,
    rebecca_stewart,
    tilman_ruff,
    glenn_begley,
    anita_elias,
    ginni_mansberg,
    rinaldo_bellomo,
    frank_gaillard,
    grace_dugan,
    tal_rapke,
    sally_bell,
    jonathan_king,
    helen_malcolm,
    peter_morley,
    frank_oberklaid,
    kelley_withy,
    joseph_proietto,
    andrew_pattison,
    michael_bonning,
    yvonne_ho,
    adir_shiffman,
    louise_teo,
    jim_black,
    brendan_nelson,
    yumiko_kadota,
    dr_karl,
    patrick_mcgorry,
    raffy_halim,
    renee_lim,
    richard_di_natale,
    ashe_coxon,
    simon_judkins,
    linny_kimly_phuong,
    tim_read,
    chandrashan_perera,
    kate_tyson,
    exam_edition_1,
    exam_edition_2,
    michael_levitt,
    murray_esler,
    matthew_chan,
    ian_harris,
    peter_blamey,
    june_brundell,
    skye_kinder,
    bradley_frew,
    melanie_tan,
    brian_spain,
    evelyn_chan,
    katie_allen,
    roy_robins,
    marian_dover,
    jan_coles,
    thailand_covidsation,
    melissa_kang,
    bronwyn_king,
    allison_hempenstall,
    david_lam,
    robbie_gillies,
    khoa_cao,
]

export default post_images_array